module.exports = __webpack_public_path__ + "img/cc5389e2-f819-4487-bb80-82762ef0349d.4b546b62.webp";